import { createRoot } from 'react-dom/client';
import AppProviders from './AppProviders';

const container = document.getElementById('app');

const root = createRoot(container);
root.render(<AppProviders />);
